import { render, staticRenderFns } from "./seeDetails.vue?vue&type=template&id=0ea8c870&scoped=true&"
import script from "./seeDetails.vue?vue&type=script&lang=js&"
export * from "./seeDetails.vue?vue&type=script&lang=js&"
import style0 from "./seeDetails.vue?vue&type=style&index=0&style=true&lang=scss&"
import style1 from "./seeDetails.vue?vue&type=style&index=1&id=0ea8c870&style=true&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8c870",
  null
  
)

component.options.__file = "seeDetails.vue"
export default component.exports